var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showblock)?_c('div',{staticClass:"black",on:{"click":_vm.stoptimer}},[_vm._v(" click to start game")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }